"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrolledPast;
var _react = require("react");
var _validators = require("../server/validators");
function useScrolledPast(elementId) {
  var [scrolledPast, setScrolledPast] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    var _window$location$host, _window;
    var isInnBusiness = (0, _validators.isInnBusinessApp)((_window$location$host = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.host) !== null && _window$location$host !== void 0 ? _window$location$host : '');
    var mainElement = document.querySelector('main');
    var hasScrolledPastLastRateCard = () => {
      var referencedElementScroll = isInnBusiness ? mainElement === null || mainElement === void 0 ? void 0 : mainElement.scrollTop : window.scrollY;
      var element = document.getElementById(elementId);
      if (element && referencedElementScroll && referencedElementScroll > element.getBoundingClientRect().top + element.offsetHeight) {
        setScrolledPast(true);
      } else {
        setScrolledPast(false);
      }
    };
    var eventListenerElement = isInnBusiness ? mainElement : document;
    eventListenerElement === null || eventListenerElement === void 0 || eventListenerElement.addEventListener('scroll', hasScrolledPastLastRateCard);
    return () => {
      eventListenerElement === null || eventListenerElement === void 0 || eventListenerElement.removeEventListener('scroll', hasScrolledPastLastRateCard);
    };
  }, []);
  return scrolledPast;
}